import { Injectable } from '@angular/core';
import { AmdocsAppsyncClientService } from 'amdocs-core-package';
import { Observable, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CONSTANTS } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class SaveUserActivityService {
  private readonly API_ENDPOINT: string;

  constructor(
    private appSyncClient: AmdocsAppsyncClientService,
    private http: HttpClient
  ) {
    // Use the GraphQL endpoint from environment
    this.API_ENDPOINT = environment.graphQlBaseURL || '/graphql';
  }

  saveUserActivity(sessionContextInput?): Observable<any> {
    const saveUserActivityQuery = `mutation saveDacUserActivity($sessionContextInput: SessionContextInput!) {
    saveDacUserActivity(sessionContextInput: $sessionContextInput) {
         isSuccess
       }
    }
`;
    const paramsvalues = {
     sessionContextInput: sessionContextInput,
    };
    return this.appSyncClient
      .call(saveUserActivityQuery,'saveDacUserActivity', paramsvalues)
      .pipe(
        mergeMap((res: any): Observable<any> => {
          return of(res);
        }),
        catchError((err) => {
          console.log(err);
          return of({ error: err });
        })
      );
  }

}